/**
 * TinyMCE editor configuration for the memo content editor
 */

// Base configuration for TinyMCE
export const tinyMCEConfig = {
  // API key - if you're using the cloud version, uncomment and add your API key
  license_key: 'gpl',

  source: "https://dev.nsuk.edu.ng/js/tinymce/tinymce.min.js",

  // Using the self-hosted version without an API key

  // Core editor configuration
  menubar: true,
  statusbar: true,

  // Display options
  height: 500,
  resize: true,
  autoresize_bottom_margin: 50,

  // Basic plugins for rich text editing
  plugins: [
    'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
    'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
    'insertdatetime', 'media', 'table', 'help', 'wordcount', 'autoresize'
  ],

  // Toolbar configuration with table support
  toolbar: 'undo redo | blocks | ' +
    'bold italic forecolor | alignleft aligncenter ' +
    'alignright alignjustify | bullist numlist outdent indent | ' +
    'table tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | ' +
    'tableinsertcolbefore tableinsertcolafter tabledeletecol | ' +
    'removeformat | help',

  // Content styling
  content_style: `
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif; font-size: 16px; }
    table { border-collapse: collapse; width: 100%; margin-bottom: 1em; }
    table td, table th { border: 1px solid #ddd; padding: 8px; min-width: 50px; }
    table tr:nth-child(even) { background-color: #f2f2f2; }
    table th { padding-top: 12px; padding-bottom: 12px; text-align: left; background-color: #f0f0f0; color: #333; }
    pre { white-space: pre-wrap; margin-bottom: 1em; padding: 0.5em; background-color: #f0f0f0; border-radius: 4px; }
    p, h1, h2, h3, h4, h5, h6, blockquote, ol, ul { margin-bottom: 1em; }
  `,

  // Table options
  table_default_attributes: {
    border: '1'
  },

  table_default_styles: {
    'border-collapse': 'collapse',
    'width': '100%'
  },

  // Additional configuration
  branding: false,
  elementpath: false,
  promotion: false,

  // Format options
  formats: {
    alignleft: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li', styles: { textAlign: 'left' } },
    aligncenter: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li', styles: { textAlign: 'center' } },
    alignright: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li', styles: { textAlign: 'right' } },
    alignjustify: { selector: 'p,h1,h2,h3,h4,h5,h6,td,th,div,ul,ol,li', styles: { textAlign: 'justify' } }
  },

  // Default settings for paste operations
  paste_data_images: true,
  paste_as_text: false,
  paste_enable_default_filters: true,

  // Image handling
  image_advtab: true,
  image_dimensions: true,

  // Misc options
  browser_spellcheck: true,
  contextmenu: "link table"
};

export default tinyMCEConfig;
